import { replayIntegration, type ErrorEvent } from "@sentry/react";

const BROWSER_CONNECTIVITY_FINGERPRINT = "browser-connectivity-diagnostics";

export function shouldSampleReplayForError(event: ErrorEvent): boolean {
  return event.fingerprint?.[0] !== BROWSER_CONNECTIVITY_FINGERPRINT;
}

export function createReplayIntegration() {
  return replayIntegration({ beforeErrorSampling: shouldSampleReplayForError });
}
